import { DEFAULT_LANGUAGE } from '../i18n/i18n';
import { NON_US_REGION, US_REGION } from './app-legal-regions';
import boundlyLogoSrcWhite from './assets/images/boundly-logo-new.png';
import boundlyLogoSrc from './assets/images/boundly-logo-white-new.png';

const uiConfig = {
    name: 'Boundly',
    logoWhite: boundlyLogoSrcWhite,
    logo: boundlyLogoSrc,
    supportEmail: 'support@bound.ly',
    domain: 'bound.ly',
    domainTitle: 'Bound.ly',
    prelanderLink: 'https://quiz.bound.ly',
    helpCenterLink: 'https://help.boundly.com',
    deviceIdKey: 'boundly_device_id',
    faqForEuConsumersLinks: {
        en: '/faq-for-eu-consumers.html',
        de: '/de/faq-for-eu-consumers.html'
    },
    legalLinks: {
        [US_REGION]: {
            en: {
                termsOfUse: '/terms-of-use.html',
                privacyPolicy: '/privacy-policy.html'
            }
        },
        [NON_US_REGION]: {
            en: {
                termsOfUse: '/terms-of-use-non-us.html',
                privacyPolicy: '/privacy-policy-non-us.html'
            },
            de: {
                termsOfUse: '/de/terms-of-use.html',
                privacyPolicy: '/de/privacy-policy.html'
            }
        }
    },
    legalEntity: {
        [US_REGION]: {
            year: 2025,
            company: 'Futureproof Limited',
            address: '9805 Double R Blvd, Suite 300, Reno, Nevada, 89521, USA',
            telephone: {
                link: 'tel:+14247990744',
                text: '+1 (424) 799-0744'
            }
        },
        [NON_US_REGION]: {
            year: 2026,
            company: 'Remenia Limited',
            address: 'GRAMMOU, 2. STROVOLOS, 2006 Nicosia, Cyprus',
            registrationNumber: 'HE 500105',
            vatNumber: '',
            telephone: {
                link: 'tel:+14247990744',
                text: '+1 (424) 799-0744'
            }
        }
    }
};

const getLegalLinks = (region, lang = DEFAULT_LANGUAGE) => {
    const regionLinks = uiConfig.legalLinks?.[region] || uiConfig.legalLinks[NON_US_REGION];

    return regionLinks?.[lang] || regionLinks?.[DEFAULT_LANGUAGE] || regionLinks;
};

const getLegalEntity = region => uiConfig.legalEntity?.[region] || uiConfig.legalEntity[NON_US_REGION];


export {
    uiConfig,
    getLegalLinks,
    getLegalEntity
};
